export const SECTIONS = [
  {
    id: 1,
    title: "Decision Making",
    subtitle: "Answer honestly — not who you want to be, but who you've been.",
  },
  {
    id: 2,
    title: "Relationships",
    subtitle: "These patterns show up in how you hold space for others — and what it costs you.",
  },
  {
    id: 3,
    title: "Identity",
    subtitle: "How you measure yourself. What drives you. What it costs you to keep up.",
  },
  {
    id: 4,
    title: "Action",
    subtitle: "Where your energy goes. Where it stalls. What you sense is next.",
  },
];

export const QUESTIONS = [
  // Section 1 – Decision Making
  { id: 1, section: 1, text: "I feel like I need more clarity before I can commit to something.", archetype: "Navigator" },
  { id: 2, section: 1, text: "I delay decisions when I feel overwhelmed.", archetype: "Avoider" },
  { id: 3, section: 1, text: "I explore different paths but struggle to choose one.", archetype: "Navigator" },
  { id: 4, section: 1, text: "I tend to wait for the right moment before acting.", archetype: "Avoider" },
  { id: 5, section: 1, text: "I feel close to figuring things out but — not quite.", archetype: "Navigator" },
  { id: 6, section: 1, text: "I sense that something in my life needs to change.", archetype: "Reclaimer" },

  // Section 2 – Relationships
  { id: 7, section: 2, text: "I feel responsible for other people's emotions.", archetype: "Keeper" },
  { id: 8, section: 2, text: "I tend to prioritize other people's needs over my own.", archetype: "Keeper" },
  { id: 9, section: 2, text: "I carry emotional weight that doesn't really belong to me.", archetype: "Keeper" },
  { id: 10, section: 2, text: "I hold back my truth to keep the peace.", archetype: "Stabilizer" },
  { id: 11, section: 2, text: "I avoid conflict even when something is genuinely bothering me.", archetype: "Stabilizer" },
  { id: 12, section: 2, text: "I stay calm on the outside even when I'm not calm on the inside.", archetype: "Stabilizer" },

  // Section 3 – Identity
  { id: 13, section: 3, text: "I can succeed and perform even when I don't feel aligned.", archetype: "Performer" },
  { id: 14, section: 3, text: "I feel pressure to maintain a certain image or expectation.", archetype: "Performer" },
  { id: 15, section: 3, text: "I measure my success based on how it looks to others.", archetype: "Performer" },
  { id: 16, section: 3, text: "I tie my sense of worth to what I accomplish.", archetype: "Prover" },
  { id: 17, section: 3, text: "I feel like I must constantly improve or I'm falling behind.", archetype: "Prover" },
  { id: 18, section: 3, text: "I struggle to feel like I am genuinely enough.", archetype: "Prover" },

  // Section 4 – Action
  { id: 19, section: 4, text: "I distract myself instead of taking action on what matters.", archetype: "Avoider" },
  { id: 20, section: 4, text: "I delay action even when I know exactly what I need to do.", archetype: "Avoider" },
  { id: 21, section: 4, text: "I lose momentum after the initial excitement of something new.", archetype: "Innovator" },
  { id: 22, section: 4, text: "I have ideas but struggle to bring them into reality.", archetype: "Innovator" },
  { id: 23, section: 4, text: "My vision for my life feels ahead of where I currently am.", archetype: "Innovator" },
  { id: 24, section: 4, text: "I feel like I am outgrowing my current life.", archetype: "Reclaimer" },
];

export const LIKERT_OPTIONS = [
  { value: 0, label: "Strongly Disagree" },
  { value: 1, label: "Disagree" },
  { value: 2, label: "Neutral" },
  { value: 3, label: "Agree" },
  { value: 4, label: "Strongly Agree" },
];

export const LOADING_PHRASES = [
  "Mapping your identity patterns...",
  "Analyzing your responses...",
  "Identifying your primary archetype...",
  "Generating your personalized report...",
  "Almost there...",
];
